import { AiFillAmazonCircle } from 'react-icons/ai'

export default {
  title: 'Amazon Settings',
  icon: AiFillAmazonCircle,
  name: 'amazonSettings',
  type: 'document',
  // __experimental_actions: ['update', 'publish'],
  fields: [
    {
      name: 'cta',
      type: 'object',
      title: 'Add-to-cart CTA',
      description:
        'This CTA is shown below the add-to-cart button. Some field values can be overriden by individual product settings.',
      fields: [
        {
          name: 'image',
          type: 'image',
          title: 'Image'
        },
        {
          name: 'text',
          type: 'string',
          title: 'Text'
        },
        {
          name: 'url',
          type: 'url',
          title: 'URL'
        }
      ]
    }
  ]
}
